import React, { useState } from 'react';
import HexMap from '../../../Carte';
import CountryActionPopin from '../../../CountryActionPopin';

const MapSlide = ({ slide, slideKey, mapData, mapAnimationPhase, onMapAnimationPhase }) => {
    const [selectedCountryPopin, setSelectedCountryPopin] = useState(null);

    const handleCountryClick = ({ countryShortName }) => {
        if (countryShortName === "Neo Atlas" && mapAnimationPhase < 1) {
            onMapAnimationPhase(1);
            return;
        }
        if (countryShortName === "Autoristan") {
            setSelectedCountryPopin({
                countryShortName: "Autoristan",
                status: "ennemi",
                data: { population: "42M", natural_resources: 65 },
                lose: false,
                currentActionHex: null
            });
        }
    };

    const handleAttack = (action) => {
        if (action === "Attaquer") {
            onMapAnimationPhase(2);
        }
        setSelectedCountryPopin(null);
    };

    return (
        <div key={slideKey} className="h-full flex flex-col p-8 animate-fade-in">
            <div className="mb-4">
                <h2 className="text-5xl font-bold text-white mb-2 animate-fade-in-up">
                    {slide.title}
                </h2>
                <p className="text-2xl text-blue-200/60 animate-fade-in-up stagger-1">
                    {slide.subtitle}
                </p>
            </div>

            <div className="flex-1 bg-blue-500/80 rounded-2xl border border-blue-500/20 backdrop-blur-xl relative overflow-hidden shadow-2xl animate-fade-in stagger-2">
                <div className="absolute inset-0 z-10 pointer-events-none bg-[radial-gradient(circle_at_center,transparent_40%,rgba(0,0,0,0.4))]" />
                <div className="w-full h-full transform transition-transform duration-700">
                    {mapData ? (
                        <HexMap
                            countries_dict={mapData.countries}
                            ocean={[]}
                            gridData={mapData.grid}
                            onOpenPopin={handleCountryClick}
                            animationPhase={mapAnimationPhase}
                        />
                    ) : (
                        <div className="flex items-center justify-center h-full text-blue-400">
                            Chargement des données satellites...
                        </div>
                    )}
                </div>
            </div>

            <CountryActionPopin
                selectedCountryPopin={selectedCountryPopin}
                handleClosePopin={() => setSelectedCountryPopin(null)}
                addMapAction={handleAttack}
                removeMapAction={() => setSelectedCountryPopin(null)}
                canPerformAction={true}
            />
        </div>
    );
};

export default MapSlide;
